export default class ContactForm {
  constructor(component) {
    this.dom = {
      $component: component,
      $select: component.querySelector('.js-select')
    }

    this.state = {
    }
    this.selectChangeHandler = this.selectChange.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this

    dom.$select.addEventListener('change', this.selectChangeHandler)
  }

  selectChange () {
    const {dom} = this
    dom.$select.style.color = '#000'
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ContactForm = this
  }
}
